export const STAGES = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  ERROR: 'error',
}
